import {
  TitledSection,
  VerticalTabPanel,
  VerticalTabPanelProps
} from '../../../components'

export interface MessagesLayoutProps<T> extends VerticalTabPanelProps<T> {
  headerTranslationId: string
}

export const MessagesLayout = <T,>({
  headerTranslationId,
  ...tabPanelProps
}: MessagesLayoutProps<T>) => {
  return (
    <TitledSection translationid={headerTranslationId}>
      <VerticalTabPanel {...tabPanelProps} />
    </TitledSection>
  )
}
